import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ContentHeaderDescriptionContainer } from "~/components/PageHeader/ContentHeaderDescriptionContainer";
import { EditableContentHeaderDescription } from "~/components/PageHeader/EditableContentHeaderDescription";
import { BOARD_BLURB_DESCRIPTION } from "~/constants/testIDs";
export const BoardHeaderDescription = /*#__PURE__*/ memo((param)=>{
    let { description, onSubmit, className } = param;
    return /*#__PURE__*/ _jsx(ContentHeaderDescriptionContainer, {
        className: className,
        children: /*#__PURE__*/ _jsx(EditableContentHeaderDescription, {
            label: "Board description",
            text: description,
            onSubmit: onSubmit,
            testId: BOARD_BLURB_DESCRIPTION
        })
    });
});
BoardHeaderDescription.displayName = "BoardHeaderDescription";
